import { CIMSPage } from '@cims-online/shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { RFIOrganization } from '../../../OrganizationsTableContext'
import { HelpMessage } from 'utils/constants'

export function useExpandOptions(): ExpandOptions<RFIOrganization> {
  return {
    expandable: ({ requestsForInformation }) => !!requestsForInformation.length,
    render: ({ id, requestsForInformation }) => {
      return {
        additionalInfo: [
          {
            label: "Associated RFI's",
            help: HelpMessage.RequestsForInformation.Organizations
              .AssociatedRFIs,
            type: 'deepLinks',
            showMore: { key: id },
            links: requestsForInformation.map(
              ({ id, formattedNumber, deleted }) => ({
                label: formattedNumber,
                page: CIMSPage.RFITracker,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
      }
    },
  }
}
